export default "__VITE_ASSET__B26whK81__"